<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10" cy="10" r="4.5" stroke="currentColor" stroke-width="1.5"/>
<circle cx="10" cy="10" r="1.75" fill="currentColor"/>
<path d="M10 1v3M10 16v3M1 10h3M16 10h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
